import { Trans, useLingui } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import { QuestionnaireTypes } from "../../../api";
import { AppModel } from "../../../app/app-model";
import { Button } from "../../../components/ui-kit/button";
import { Select } from "../../../components/ui-kit/fields/select";
import { questionnaireTypes } from "../../../constants/enum-to-text";
import { PatientSubpage } from "../common/patient-subpage";
import { Questionnaire } from "./questionnaire";
import { QuestionnaireStats } from "./questionnaire-stats";

export const QuestionnaireRoute = observer(function QuestionnaireRoute(props: {
  app: AppModel;
}) {
  const { t } = useLingui();
  const patient = props.app.requirePatient();
  const api = props.app.seerlinqApi;
  const [type, setType] = useState(QuestionnaireTypes.eq_5d_5l);
  const [showQuestionnaire, setShowQuestionnaire] = useState(false);
  const [showResultsFor, setShowResultsFor] = useState<QuestionnaireTypes>();

  return (
    <PatientSubpage title={t`Questionnaire`}>
      {!showQuestionnaire && (
        <>
          <Select
            values={questionnaireTypes}
            value={type}
            onChange={(newValue) => {
              setType(newValue);
            }}
          />{" "}
          <Button
            onClick={() => {
              setShowResultsFor(type);
            }}
          >
            <Trans>Load stats</Trans>
          </Button>{" "}
          <Button
            onClick={() => {
              setShowQuestionnaire(true);
            }}
          >
            <Trans>Fill out now</Trans>
          </Button>
        </>
      )}

      {showQuestionnaire && (
        <div style={{ maxWidth: "500px" }}>
          <Questionnaire
            api={api}
            patient={patient}
            type={type}
            onClose={() => {
              setShowQuestionnaire(false);
            }}
          />
        </div>
      )}

      {showResultsFor && (
        <QuestionnaireStats type={showResultsFor} patient={patient} />
      )}
    </PatientSubpage>
  );
});
